import axios from 'axios';

const jwtAxios = axios.create({});

/**
 * @template T
 * @typedef {import ('../interfaces/utils/axios.interface').ProcessedData<T>} ProcessedData
 */

/**
 * Procesa un error en la llamada, en caso de ser un error
 * no controlado en el back genera un error 400 - Axios - Bad request
 * @template T
 * @param {Object} response
 * @return {ProcessedData<T>}
 */
const _processError = (response) => {
  const status = response?.response?.status || 400;
  const error = response?.response?.data || 'Axios - Bad request';

  const message = { status, data: null, error };
  return message;
};

/**
 * Procesa un llamada correcta
 * @template T
 * @param {Object} response
 * @return {ProcessedData<T>}
 */
const _processResponse = (response) => {
  if (response.status >= 200 && response.status < 300) {
    return { status: response.status, data: response.data };
  }
  return _processError(response);
};

/**
 * Procesa un llamada para buscar un token
 * @param {string} url
 * @return {Promise<ProcessedData<string>>}
 */
const generateToken = async (url) => {
  try {
    const callResponse = await jwtAxios.get(url);
    return _processResponse(callResponse);
  } catch (err) {
    return _processError(err);
  }
};

export default generateToken;
